import styled from "@emotion/styled";

import { MDSCard } from "@/mds";

export const CardContainer = styled.div`
  width: min(640px, 100%);
  min-width: 320px;
  min-height: 208px;
`;

export const ModalCard = styled(MDSCard)`
  padding: ${({ theme }) => theme.spacing[7]};
  background: ${({ theme }) => theme.colors.surface.modal};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
`;

export const Stack = styled.div<{ spacing?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ spacing = 16 }) => `${spacing}px`};
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing[2]};
  width: 100%;
`;

export const ActionsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing[3]};
  padding-top: ${({ theme }) => theme.spacing[6]};
  width: 100%;
`;

export const PreviewContainer = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.large};
  border: 1px solid ${({ theme }) => theme.colors.border.surface};
  background: ${({ theme }) => theme.colors.surface.preview};
  padding: ${({ theme }) => theme.spacing[4]};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.fontSizes["text-sm"]};
  line-height: ${({ theme }) => theme.lineHeights["text-sm"]};
  max-height: 200px;
  overflow-y: auto;

  p {
    margin: 0 0 ${({ theme }) => theme.spacing[2]};
  }

  p:last-of-type {
    margin-bottom: 0;
  }
`;
